import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { EmptyPageModule } from '../../../empty-page/empty-page.module';
import { CollectionHeaderModule } from '../collection-header/collection-header.module';
import { TieMatchListComponent } from './tie-match-list.component';
import { TieMatchScoreboardModule } from './tie-match-scoreboard/tie-match-scoreboard.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TranslateModule.forChild(),
        EmptyPageModule,
        TieMatchScoreboardModule,
        CollectionHeaderModule
    ],
    declarations: [
        TieMatchListComponent
    ],
    exports: [
        TieMatchListComponent
    ]
})
export class TieMatchListModule { }
